import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState, useEffect } from "react";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
// import { IMaintenanceDetail, IMaintenanceSearch } from "./maintenanceTypes";
import { transPgToPagination, formatNum } from "@/utils/utils";
import { message } from "antd";

import { IMaintenanceList, IMaintenanceStatistics, IMaintenanceSearch, IMaintenanceDetail, IMaintenanceRoSettleAndWhConfirm } from "./maintenanceTypes"
import { maintenanceService } from "./maintenanceService"
import { convertRes2Blob } from "@/utils/exportFile";
export const useMaintenanceModel = createModel(function () {
    const initSearchParam: IMaintenanceSearch = {};
    const initDataSource: IMaintenanceDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: IMaintenanceStatistics = {
        amountReceived: 0,
        discountTotalAmount: 0,
        materialScienceAmount: 0,
        receivableTotalAmount: 0,
        totalAmount: 0,
        workingHoursAmount: 0,
    }
    //查询条件
    const [searchParam, setSearchParam] = useState<IMaintenanceSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMaintenanceDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IMaintenanceDetail>({});
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [descTotal, setDescTotal] = useState<IMaintenanceStatistics>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IMaintenanceStatistics>(initDesc);
    const [descRows, setDescRows] = useState<IMaintenanceDetail[]>([]);
    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IMaintenanceDetail)
    }, [selectedRowKeys])

    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { workingHoursAmount, materialScienceAmount, receivableTotalAmount, discountTotalAmount, amountReceived, totalAmount } = item
            newRowsDescTotal.amountReceived += +formatNum(amountReceived)
            newRowsDescTotal.discountTotalAmount += +formatNum(discountTotalAmount)
            newRowsDescTotal.materialScienceAmount += +formatNum(materialScienceAmount)
            newRowsDescTotal.receivableTotalAmount += +formatNum(receivableTotalAmount)
            newRowsDescTotal.totalAmount += +formatNum(totalAmount)
            newRowsDescTotal.workingHoursAmount += +formatNum(workingHoursAmount)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMaintenanceSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IMaintenanceSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await maintenanceService.page(searchParams);
        const { records, statistics, ...pg } = retData;
        setPgCfg(transPgToPagination({ ...pg, pageNum: pg.current }));
        setDescTotal(statistics);
        setDataSource(records);
    }
    const invalidateData = async (obj: object) => {
        let { retData } = await maintenanceService.invalidate(obj)
        if (retData) {
            message.success("作废成功");
            loadData();
        }
    }
    const onPrinting = async (obj: object) => {
        let { retData } = await maintenanceService.printing(obj)
        if (retData) {
            // message.success("作废成功");
            loadData();
        }
    }

    const [print, setPrint] = useState<boolean>(false);
    //列表导出
    const listExport = async () => {
        let result = await maintenanceService.export({ ...searchParam, id: selectedRowKeys.join() });
        convertRes2Blob(result)
    }
    const detailsExport = async () => {
        let result = await maintenanceService.detailsExport({
            ...searchParam,
            id: selectedRowKeys.join(),
            "pageSize": "0",
            "pageNum": "0",
        });
        convertRes2Blob(result)
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedRow,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setSelectedRow,
        invalidateData,
        print, setPrint,
        onPrinting,
        listExport,
        detailsExport,
        descTotal, setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows

    }
})
